export interface FitterOpeningHours {
  center: FitterOpeningPeriod[];
  outside: FitterOpeningPeriod[];
  webCenter?: FitterOpeningPeriod[];
  webOutside?: FitterOpeningPeriod[];
}

export interface FitterOpeningPeriod {
  open: FitterOpeningLimit;
  close: FitterOpeningLimit;
}

export interface FitterOpeningLimit {
  day: number;
  time: string;
  allDay?: boolean;
}

export interface FitterSpecificHours {
  open?: FitterSpecificHoursPeriods[];
  close?: FitterSpecificHoursPeriods[];
}

export interface FitterSpecificHoursPeriods {
  reason: string;
  startDate: string; // DD/MM/YYYY
  startTime: string; // HH:mm
  endDate: string; // DD/MM/YYYY
  endTime: string; // HH:mm
  allDay: boolean;
}
